import { render, staticRenderFns } from "./AdminManageHome.vue?vue&type=template&id=5486c5b2&scoped=true"
import script from "./AdminManageHome.vue?vue&type=script&lang=js"
export * from "./AdminManageHome.vue?vue&type=script&lang=js"
import style0 from "./AdminManageHome.vue?vue&type=style&index=0&id=5486c5b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5486c5b2",
  null
  
)

export default component.exports